<template>
  <section>
    <v-snackbar
      v-model="snackbar.show"
      :timeout="10000"
      multi-line
      left
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-btn flat @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>

    <!-- Dialog start -->

    <v-dialog v-model="dialog.loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog.delete"
      max-width="500"
      persistent
      v-if="dialog.hasLoaded"
    >
      <v-card>
        <v-card-title class="headline"
          >You Sure, about deleting this Role?</v-card-title
        >

        <v-card-text>
          Are you sure, you want to delete this role? <br />
          We suggest verifying the details before taking such an action.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="success" flat="flat" @click="dialog.delete = false">
            Don't Delete
          </v-btn>

          <v-btn color="error" flat="flat" @click="deleteRole">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- UPDATE DIALOG -->
    <v-dialog
      v-model="dialog.update"
      persistent
      v-if="dialog.hasLoaded"
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline">
          Update this Role!
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid">
            <v-text-field
              v-model="form.name"
              label="Name"
              :rules="nameRules"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="success" flat="flat" @click="dialog.update = false">
            Don't Update
          </v-btn>

          <v-btn
            color="error"
            flat="flat"
            :disabled="!valid"
            @click="updateRole"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog AddAction -->
    <v-dialog
      v-model="dialog.addAction"
      persistent
      v-if="dialog.hasLoaded"
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline">
          Add Action to this Role!
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid">
            <!--            <v-text-field
              v-model="form.name"
              label="Name"
              :rules="nameRules"
            ></v-text-field> -->

            <v-autocomplete
              :loading="dialog.loading"
              :items="resources"
              item-text="name"
              flat
              label="RESOURCE"
              v-model="addActionForm.resource"
              :search-input.sync="addActionForm.resourceSearch"
              clearable
              persistent-hint
              allow-overflow
              return-object
            />

            <v-autocomplete
              :loading="dialog.loading"
              :items="actions"
              :disabled="!addActionForm.resource"
              item-text="name"
              flat
              label="ACTION"
              v-model="addActionForm.action"
              :search-input.sync="addActionForm.actionSearch"
              clearable
              presistent-hint
              allow-overflow
              return-object
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="success" flat="flat" @click="dialog.addAction = false">
            Don't Add Action
          </v-btn>

          <v-btn
            color="error"
            flat="flat"
            :disabled="!addActionForm.resource || !addActionForm.action"
            @click="addActionToRole"
          >
            Add Action
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog end -->
    <v-alert :value="err" type="error" v-if="err">
      {{
        err.graphQLErrors.length > 0
          ? err.graphQLErrors[0].data.message
          : err.message
      }}
    </v-alert>

    <div class="act--view-main" v-if="err">
      <section>
        <v-card class="act--view-card">
          <h2 style="font-size: 50px;">
            {{
              err.graphQLErrors.length > 0
                ? err.graphQLErrors[0].data.message
                : err.message
            }}
          </h2>
        </v-card>
      </section>
    </div>

    <div class="act--view-main">
      <section>
        <v-card class="act--view-card" style="min-height: 160px;" v-if="!err">
          <p class="act--view-title">ROLE</p>
          <div class="act--view-grid-call">
            <div>
              <p class="act--view-detail-title">ID: {{ this.role.id }}</p>
              <p class="act--view-detail-title">NAME: {{ this.role.name }}</p>
            </div>
          </div>
        </v-card>
        <v-card
          class="act--view-card"
          style="background: #fff; min-height: 160px; max-height: 250px; overflow-y:scroll; padding: 25px;"
          v-if="!err"
        >
          <p class="act--view-title">ACTIONS</p>
          <v-list style="background: inherit;">
            <v-list-tile
              v-for="(action, idx) in role.actions"
              :key="action.id"
              avatar
              class="elevation-2"
              style="margin-bottom: 10px;"
            >
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ idx + 1 }}. {{ action.name }}/{{ action.resource.name }}
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <div>
                  <v-btn
                    icon
                    ripple
                    style="margin-right: 5px;"
                    :to="'/authentication/action/' + action.id"
                  >
                    <v-icon color="success">fas fa-external-link-alt</v-icon>
                  </v-btn>
                  <v-btn icon ripple @click="removeAction(action.id)">
                    <v-icon color="error">fas fa-times-circle</v-icon>
                  </v-btn>
                </div>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-card>
        <v-card class="act--view-card" v-if="!err">
          <p class="act--view-title">Modify</p>
          <div class="act--view-grid-call-comment">
            <v-btn
              color="success"
              @click="moveTo(`/authentication/role/${role.id}?addAction=1`)"
              >Add Action to Role</v-btn
            >
            <v-btn
              color="info"
              @click="moveTo(`/authentication/role/${role.id}?update=1`)"
              >UPDATE</v-btn
            >
            <v-btn
              color="error"
              @click="moveTo(`/authentication/role/${role.id}?delete=1`)"
              >DELETE</v-btn
            >
          </div>
        </v-card>
      </section>
    </div>
  </section>
</template>
<script>
import { coreClient } from "../../../apollo";
import gql from "graphql-tag";

export default {
  data() {
    return {
      role: {
        id: "",
        name: "",
        actions: []
      },
      err: "",
      snackbar: {
        show: false,
        text: "",
        color: ""
      },
      dialog: {
        loading: false,
        hasLoaded: false,
        delete: false,
        update: false,
        addAction: false
      },
      form: {
        id: "",
        name: ""
      },
      resources: [],
      actions: [],
      addActionForm: {
        resource: null,
        action: null,
        resourceSearch: "",
        actionSearch: ""
      },
      timeouts: {
        resourceSearch: null,
        actionSearch: null
      },
      valid: false,
      nameRules: [
        v => !!v || "The name wasn't found.",
        v => v.length > 2 || "The name must be longer than 2 characters."
      ]
    };
  },
  watch: {
    async "addActionForm.resource"(v) {
      if (v) {
        this.dialog.loading = true;
        await this.getActions({
          resource: this.addActionForm.resource.id
        });
        this.dialog.loading = false;
      }
    },
    "addActionForm.resourceSearch"(v) {
      clearTimeout(this.timeouts.resourceSearch);

      this.timeouts.resourceSearch = setTimeout(async () => {
        this.dialog.loading = true;
        v && (await this.getResources({ name: v }));
        this.dialog.loading = false;
      }, 500);
    },
    "addActionForm.actionSearch"(v) {
      clearTimeout(this.timeouts.actionSearch);
      this.timeouts.actionSearch = setTimeout(async () => {
        this.dialog.loading = true;
        v &&
          this.addActionForm.resource &&
          (await this.getActions({
            name: v,
            resource: this.addActionForm.resource.id
          }));
        this.dialog.loading = false;
      }, 500);
    }
  },
  methods: {
    async getRole(id) {
      this.dialog.loading = true;
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Role($id: String!) {
              Role(id: $id) {
                id
                name
                actions {
                  id
                  name
                  resource {
                    id
                    name
                  }
                }
              }
            }
          `,
          variables: { id },
          fetchPolicy: "no-cache"
        });

        this.role = data.Role;
        this.form = { ...this.role };
      } catch (e) {
        this.snackbar = {
          show: true,
          text: e.graphQLErrors[0].data.message,
          color: "error"
        };
        this.err = e;
      }

      this.dialog.loading = false;
      this.dialog.hasLoaded = true;
    },
    async updateRole() {
      this.dialog.loading = true;
      let variables = {};
      Object.keys(this.form).forEach(field => {
        if (this.resource[field] !== this.form[field]) {
          variables[field] = this.form[field];
        }
      });

      variables["id"] = this.resource["id"];
      variables["name"] = variables["name"] || "";
      delete variables["actions"];

      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation updateRole($id: String!, $name: String) {
              updateRole(id: $id, name: $name) {
                id
                name
                actions {
                  id
                  name
                  resource {
                    id
                    name
                  }
                }
              }
            }
          `,
          variables
        });

        this.role = data.updateRole;
        this.snackbar = {
          text: "The role was updated!",
          color: "success",
          show: true
        };
        this.dialog.update = false;
      } catch (e) {
        this.snackbar = {
          show: true,
          text:
            e.graphQLErrors.length > 0
              ? e.graphQLErrors[0].data.message
              : e.message,
          color: "error"
        };
      }

      this.dialog.loading = false;
    },
    async deleteRole() {},
    moveTo(uri) {
      this.$router.push(uri);
      this.$router.go();
    },
    async getResources(variables = {}) {
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Resources($name: String, $page: Int) {
              Resources(name: $name, page: $page) {
                total
                pages
                page
                docs {
                  id
                  name
                }
              }
            }
          `,
          variables
        });
        this.resources = data.Resources.docs;
      } catch (err) {
        this.snackbar = {
          text:
            err.graphQLErrors.length > 0
              ? err.graphQLErrors[0].data.message
              : err.message,
          show: true,
          color: "error"
        };
        this.err = err;
      }
    },
    async getActions(variables = {}) {
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Actions(
              $name: String
              $page: Int
              $limit: Int
              $resource: String
            ) {
              Actions(
                name: $name
                page: $page
                limit: $limit
                resource: $resource
              ) {
                total
                pages
                page
                docs {
                  id
                  name
                  resource {
                    id
                    name
                  }
                }
              }
            }
          `,
          variables: {
            ...variables,
            limit: 30
          }
        });

        this.actions = data.Actions.docs;
      } catch (err) {
        this.snackbar = {
          text:
            err.graphQLErrors.length > 0
              ? err.graphQLErrors[0].data.message
              : err.message,
          show: true,
          color: "error"
        };
        this.err = err;
      }
    },
    async removeAction(id) {
      // remove the action
      this.dialog.loding = true;
      this.dialog.delete = false;
      try {
      
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation removeActionsFromRole($id: String!, $actions: [String!]!) {
              removeActionsFromRole(id: $id, actions: $actions) {
                id
              }
            }
          `,
          variables: {
            id: this.$route.params.id,
            actions: [id]
          }
        })

        this.snackbar = {
          text: "Successfully removed action from role.",
          show: true,
          color: "success"
        };

        setTimeout(() => {
          this.moveTo("/authentication/role/" + this.$route.params.id);
        }, 1000);
      } catch (err) {
        this.snackbar = {
          text:
            err.graphQLErrors.length > 0
              ? err.graphQLErrors[0].data.message
              : err.message,
          show: true,
          color: "error"
        };
        this.err = err;
      }

      this.dialog.loading = false;
    },
    async addActionToRole() {
      this.dialog.loading = true;
      this.dialog.addAction = false;
      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation addActionsToRole($id: String!, $actions: [String!]!) {
              addActionsToRole(id: $id, actions: $actions) {
                id
              }
            }
          `,
          variables: {
            id: this.$route.params.id,
            actions: [this.addActionForm.action.id]
          }
        });

        this.snackbar = {
          text: "Successfully added action to role.",
          show: true,
          color: "success"
        };

        setTimeout(() => {
          this.moveTo("/authentication/role/" + this.$route.params.id);
        }, 1000);
      } catch (err) {
        this.snackbar = {
          text:
            err.graphQLErrors.length > 0
              ? err.graphQLErrors[0].data.message
              : err.message,
          show: true,
          color: "error"
        };
        this.err = err;
      }

      this.dialog.loading = false;
    }
  },
  async mounted() {
    await this.getRole(this.$route.params.id);
    let { query } = this.$route;

    if (query.update && query.delete) {
      return;
    }

    if (query.update) {
      this.dialog.update = true;
      return;
    }

    if (query.delete) {
      this.dialog.delete = true;
      return;
    }

    if (query.addAction) {
      this.getResources({});
      this.dialog.addAction = true;
      return;
    }

    return;
  }
};
</script>
<style lang="stylus" scoped>
@import '../../../assets/stylus/Activities_view.styl';
</style>
